import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { LedgerRow } from '../../services/adsService';
import { formatPoints, formatDateTime } from '../../utils/adsHelpers';

interface LedgerTableProps {
  data: LedgerRow[];
  loading: boolean;
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number, pageSize?: number) => void;
}

export const LedgerTable: React.FC<LedgerTableProps> = ({
  data,
  loading,
  page,
  pageSize,
  total,
  onPageChange,
}) => {
  const columns: ColumnsType<LedgerRow> = [
    {
      title: 'Ledger ID',
      dataIndex: 'id',
      key: 'id',
      width: 120,
      ellipsis: true,
      render: (v: string) => (v ? `${v.slice(0, 8)}...` : '–'),
    },
    {
      title: 'Order ID',
      dataIndex: 'orderId',
      key: 'orderId',
      width: 100,
      render: (v: number) => `#${v}`,
    },
    {
      title: 'Điểm',
      dataIndex: 'points',
      key: 'points',
      width: 90,
      align: 'right' as const,
      render: (v: number) => `-${formatPoints(v)}`,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status: string) => (
        <Tag color={status === 'SUCCESS' ? 'green' : 'red'}>
          {status === 'SUCCESS' ? 'Thành công' : 'Thất bại'}
        </Tag>
      ),
    },
    {
      title: 'Lý do',
      dataIndex: 'reason',
      key: 'reason',
      width: 140,
      ellipsis: true,
      render: (v: string | null | undefined, record: LedgerRow) =>
        record.reason ??
        (record.status === 'SUCCESS' ? 'Đơn giao thành công' : '–'),
    },
    {
      title: 'Thời gian',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 140,
      render: (v: string) => formatDateTime(v),
    },
  ];

  return (
    <Table<LedgerRow>
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (t, range) => `${range[0]}-${range[1]} / ${t}`,
      }}
      onChange={pagination => {
        const current = pagination?.current ?? page;
        const size = pagination?.pageSize ?? pageSize;
        onPageChange(current, size);
      }}
    />
  );
};
